import configJson from "./clientAppSettings.json";
import configJsonDev from "./clientAppSettings.Development.json";

export default function getConfig() {
    let config = configJson;
    if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
        config = configJsonDev;
    }

    const audience =
        config.Auth0?.audience && config.Auth0.audience !== "YOUR_API_IDENTIFIER"
            ? config.Auth0.audience
            : null;

    return {
        domain: config.Auth0?.domain,
        clientId: config.Auth0?.clientId,
        ...(audience ? { audience } : null),
        apiUrl: config.API_URL,
        logoDevToken: config.LogoDevToken || "",
        TemplateStudio: {
            apiKey: config.TemplateStudio?.apiKey || "",
            clientId: config.TemplateStudio?.clientId || "",
            meBaseUrl: config.TemplateStudio?.meBaseUrl || "",
            projectId: config.TemplateStudio?.projectId || "",
        },
        PricingMatrix: {
            // isVisible: config.PricingMatrix?.isVisible,
            SocketUrl: config.PricingMatrix?.SocketUrl || 'https://test-socket.enerex.com',
            // isSystemAdminAccessOnly: config.PricingMatrix?.isSystemAdminAccessOnly,
            SocketClientId: config.PricingMatrix?.SocketClientId || 'b576c01556f54206b35aa63a09a8196d',
            SocketApiKey: config.PricingMatrix?.SocketApiKey || '4a9c54c4-14fa-46b2-b04d-2a7316037445',
        },
        DefaultClientId: config?.DefaultClientId,
        GA_ID: config?.GA_ID     // engie enerexId
    };
}
